import { useContext } from 'react';

import { PageTitleContext } from '../providers/PageTitleProvider';

const usePageTitle = () => {
  return useContext(PageTitleContext);
};

export default usePageTitle;
